import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import IconButton from 'material-ui/IconButton'
import EditIcon from 'material-ui/svg-icons/editor/mode-edit'
import Paper from 'material-ui/Paper'
import Account from 'material-ui/svg-icons/action/account-circle'
import styled from 'styled-components'
import images from '../../config/images'

const PaperBackground = styled(Paper)`
  background-image: url(${images.cardBackground});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
`

export default class Card extends Component {
  render () {
    return (
      <div className={`dib ${this.props.className}`}>
        <Paper
          className='image-contact br-100 flex justify-center items-center'
          circle
          zDepth={2}
          style={{backgroundColor: '#3895F3', width: 185, height: 185}}>
          <div className='flex justify-center items-center h-100'>
            <Account style={{width: 80, height: 80, fill: '#FFFFFF'}}/>
          </div>
          <div className='overlay-contact br-100'>
            <PaperBackground
              style={{borderRadius: '100%', height: '100%'}}>
              <div
                style={{background: 'rgba(0,0,0,0.7)'}}
                className='flex justify-center items-center h-100 br-100'>
                <Link to={{
                  pathname: `/admin/contact-list/${this.props.name}`,
                  state: {id: this.props.id}
                }}>
                  <IconButton
                    iconStyle={{width: 80, height: 80, fill: '#FFFFFF'}}
                    style={{height: 190, width: 190}}>
                    <EditIcon/>
                  </IconButton>
                </Link>
              </div>
            </PaperBackground>
          </div>
        </Paper>
        <div className='tc pt3' style={{fontSize: 14, color: '#6B7C93'}}>
          {this.props.name}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ContactList/Card.js